const EN = {
  nav: {
    links: [
      { label: "Home", href: "#home" },
      { label: "How It Works", href: "#how" },
      { label: "FAQ", href: "#faq" },
      { label: "Contact", href: "#contact" },
    ],
    cta: "Request a Free Device Demonstration",
    language: "Language",
    comingSoon: (label) => `${label} is coming soon`,
    comingSoonDesc: "We're preparing fully translated content.",
  },
  hero: {
    label: "IN-PERSON GIVING & DIGITAL GROWTH SOLUTIONS",
    lines: ["Make Giving Easier.", "Keep Your Church", "Connected."],
    sub: "Provide your members with another convenient way to give during services using an eligible card or contactless payment method—supported by professional websites, online giving, QR codes, communication tools, training, and ongoing digital assistance.",
    cta1: "Request a Free Device Demonstration",
    cta2: "Explore Our Solutions",
    trust: ["Transparent service", "Built for ministry", "Multilingual support", "Based in South Florida"],
    contactless: "Contactless",
    tap: "Tap to give",
    imgAlt: "A member tapping a contactless card on a modern giving device during a service",
  },
  demoCta: {
    title: "See How In-Person Giving Can Work for Your Church",
    text: "Schedule a complimentary demonstration to explore the device, understand the qualification process, and discover how it can connect with your church's complete digital system.",
    button: "Request My Free Demonstration",
    note: "No obligation. Provider approval and equipment availability may apply.",
  },
  benefits: {
    label: "Why Churches Choose Konek",
    title: "Three Ways Konek Serves Your Ministry",
    items: [
      { title: "More Convenient Giving Options", desc: "Eligible members can use supported cards or contactless payment methods during services and events." },
      { title: "One Connected Church System", desc: "The device can be supported by a professional website, online giving, QR codes, events, visitor forms, and communication tools." },
      { title: "Training and Ongoing Support", desc: "We help your church representatives understand and manage your digital systems—even without a dedicated technical employee." },
    ],
  },
  deviceVideo: {
    label: "Device Demonstration",
    title: "Watch the Giving Device in Action",
    text: "An official demonstration video will be added here soon. In the meantime, church leaders can request a personalized live demonstration.",
    soonLabel: "Official Device Demonstration Coming Soon",
    button: "Request a Live Demonstration",
  },
  howGiving: {
    label: "How In-Person Giving Works",
    title: "Three Simple Steps During Any Service",
    step: "STEP",
    steps: ["Choose the contribution amount", "Tap, insert, or use an eligible payment method", "Receive confirmation"],
    usesTitle: "Where churches use it:",
    uses: ["Regular worship services", "Special offerings", "Building campaigns", "Conferences", "Fundraising programs", "Community events"],
    disclaimer: "Approval, equipment, processing rates, deposits, and contractual terms are determined by participating third-party payment-processing providers. Konek Church is not a payment processor and never holds church donations.",
  },
  marquee: ["Built for Ministry", "Secure Giving", "Multilingual Support", "One Connected Partner", "Care for Your Congregation"],
  why: {
    label: "Why Konek Church",
    title: "A Partner Who Understands Your Ministry",
    sub: "We serve churches with cultural understanding, personal care, and one coordinated service for both giving and websites.",
    points: [
      "We understand church culture and ministry needs",
      "Personal, human service — never a call center",
      "One coordinated partner for giving and websites",
      "Support for churches with no dedicated tech staff",
    ],
    langsTitle: "4 languages",
    langsSub: "English · Kreyòl · Français · Español",
    imgAlt: "A joyful, multicultural church community gathered together",
  },
  how: {
    label: "How It Works",
    title: "A Simple Path From Idea to Launch",
    sub: "Four clear steps — no technical background required. We guide your church every step of the way.",
    steps: [
      { n: "01", title: "Free Consultation", desc: "We learn about your church and its needs." },
      { n: "02", title: "Personalized Recommendation", desc: "We recommend the right solution for your ministry and budget." },
      { n: "03", title: "Setup", desc: "We coordinate approved services and build your digital solution." },
      { n: "04", title: "Launch & Support", desc: "We launch, train your team, and provide support when needed." },
    ],
  },
  solutions: {
    label: "Complete Digital Church Solution",
    title: "Everything Your Ministry Needs, Connected",
    sub: "One trusted partner for giving, websites, communication, and ongoing support.",
    viewAll: "View All Solutions",
    viewLess: "Show Less",
    items: [
      { title: "In-Person Giving-Device Assistance", desc: "A simple, familiar way to give during services." },
      { title: "Professional Church Website", desc: "A clean, welcoming, mobile-friendly church website." },
      { title: "Online Giving", desc: "Secure giving from anywhere, any day of the week." },
      { title: "Donation QR Codes", desc: "Tap-to-give codes for bulletins, screens, and events." },
      { title: "Events & Registration", desc: "Publish events and collect sign-ups with ease." },
      { title: "Livestream & Sermons", desc: "Bring worship and past messages online." },
      { title: "Visitor & Prayer-Request Forms", desc: "Welcome guests and follow up with care." },
      { title: "Email & Member Communication", desc: "Newsletters that keep everyone connected." },
      { title: "Multilingual Options", desc: "Serve your church in English, Kreyòl, French, or Spanish." },
      { title: "Training", desc: "We teach your team to run your digital tools with confidence." },
      { title: "Ongoing Support", desc: "A partner to call when you have no tech staff." },
    ],
  },
  packages: {
    label: "Simple, Accessible Pricing",
    title: "Modern Church Technology Should Be Accessible to Every Ministry",
    sub: "Whether you lead a small congregation or a growing ministry, we'll help you find a solution that fits your needs, goals, and budget.",
    startingAt: "Starting at",
    mostPopular: "Most Popular",
    disclaimer: "Konek Church service pricing is separate from third-party payment-processing rates, equipment costs, transaction fees, hosting, software, and provider contracts. Final pricing depends on your church's requirements.",
    process: "How it works: Free consultation → Personalized recommendation → Signed agreement → Private payment link for the 50% deposit → Production → Final approval and remaining balance → Launch.",
    items: [
      {
        name: "Essential", price: "$997", popular: false,
        tagline: "An affordable way to establish or improve your church's digital giving and online presence.",
        cta: "Request a Consultation",
        features: ["Payment-provider application assistance", "Eligible giving-device setup assistance", "Essential church website", "Online-giving connection", "Donation QR code", "Contact & prayer-request form", "Social-media connections", "Basic training & initial website support"],
      },
      {
        name: "Growth", price: "$1,497", popular: true,
        tagline: "A stronger, more complete digital system for growing ministries.",
        cta: "Request a Consultation",
        inherits: "Everything in Essential, plus:",
        features: ["Expanded website", "Events & registration", "Visitor connection forms", "Livestream & sermon integration", "Newsletter signup", "Website analytics", "Additional training & support"],
      },
      {
        name: "Complete", price: "$2,497", popular: false,
        tagline: "An advanced digital presence and ongoing ministry technology.",
        cta: "Request a Consultation",
        inherits: "Everything in Growth, plus:",
        features: ["Larger website", "Multilingual options", "Multiple campaign pages", "Advanced event registration", "Volunteer & membership forms", "Automated visitor follow-up", "Appointment / pastoral-request system", "Advanced analytics & priority support"],
      },
    ],
  },
  care: {
    label: "Optional Ongoing Care",
    title: "Clear Monthly Support Plans",
    sub: "Keep your website healthy and current. Every plan lists exactly what's included, how updates work, and how quickly we respond.",
    notIncluded: "Not included: ",
    plans: [
      {
        name: "Foundation Care", price: "$149", per: "/month",
        includes: ["Software updates & backups", "Security monitoring", "Up to 2 content updates / month", "Email support · 2 business-day response"],
        excludes: "New pages, redesigns, or integrations are quoted separately.",
      },
      {
        name: "Growth Care", price: "$299", per: "/month",
        includes: ["Everything in Foundation Care", "Up to 5 content updates / month", "Event & form updates + testing", "Monthly analytics summary", "Email & text support · 1 business-day response"],
        excludes: "Does not include large redesigns or new integrations.",
      },
      {
        name: "Ministry Management", price: "$599", per: "/month",
        includes: ["Everything in Growth Care", "Up to 10 content updates / month", "Priority support · same business-day response", "Communication assistance", "Quarterly strategy check-in"],
        excludes: "Custom development is scoped separately. Plans are not unlimited.",
      },
    ],
  },
  trust: {
    label: "Why Trust Konek Church",
    title: "Meet the Founder Behind Konek Church",
    sub: "Abner Sergilles created Konek Church to help churches use practical digital tools for giving, communication, connection, and ministry growth. His experience within church communities helps Konek Church approach every project with respect, personal service, and an understanding of ministry needs.",
    founderName: "Abner Sergilles",
    founderRole: "Founder of Konek Church",
    facts: [
      { label: "Location", value: "South Florida" },
      { label: "Languages", value: "English, Haitian Creole, French & Spanish" },
      { label: "Email", value: "hello@konekchurch.com" },
    ],
    legal: "Konek Church is operated by Konekte Haitians LLC.",
    photoSoon: "Founder photo coming soon",
    videoTitle: "A Message From Our Founder",
    videoDesc: "The founder's introduction and Konek Church presentation video will be uploaded here soon.",
    cards: [
      { title: "4 languages", desc: "English · Kreyòl · Français · Español" },
      { title: "Clear, honest terms", desc: "Payment processing is handled by approved third-party providers." },
      { title: "Ministry-first", desc: "Built to serve churches of every size and budget." },
    ],
    firstStory: "Be among the first churches we serve — your story could be featured here.",
  },
  form: {
    label: "Free Demonstration",
    title: "Ready to Explore a Better Giving Experience for Your Church?",
    sub: "A few quick details — that's it. We'll reach out within one business day. No pressure, no obligation.",
    benefits: [
      { t: "One business-day response", d: "A real person follows up quickly." },
      { t: "Personalized recommendation", d: "Guidance for your ministry and budget." },
      { t: "No obligation", d: "Explore your options with confidence." },
    ],
    prefer: "Prefer to speak with someone?",
    contactLabels: { call: "Call", text: "Text", whatsapp: "WhatsApp", email: "Email" },
    labels: {
      name: "Pastor or representative name", church: "Church name", role: "Leadership role",
      email: "Email", phone: "Phone", location: "Church location", language: "Preferred language",
      interest: "I'm interested in", contactMethod: "Preferred contact method",
    },
    placeholders: { name: "Full name", church: "Church name", role: "e.g. Pastor, Deacon, Administrator", email: "you@church.org", phone: "(000) 000-0000", location: "City, State" },
    interestDevice: "The in-person giving device",
    interestWebsite: "A church website & digital tools",
    contactOptions: [
      { value: "Phone call", label: "Phone call" },
      { value: "Text message", label: "Text message" },
      { value: "WhatsApp", label: "WhatsApp" },
      { value: "Email", label: "Email" },
    ],
    hint: "Email or phone — at least one.",
    errors: {
      name: "Please enter your name.",
      church: "Please enter your church name.",
      interest: "Please choose at least one interest.",
      contact: "Enter an email or phone so we can reach you.",
    },
    optin: 'It\'s okay to show my church\'s name in Konek\'s recent-activity notifications (e.g., "First Baptist requested a consultation").',
    optional: "Optional.",
    submit: "Request My Free Demonstration",
    sending: "Sending…",
    privacy: "We'll only use your information to contact you about your demonstration.",
    toastOk: "Request received — we'll be in touch within one business day.",
    toastErr: "Something went wrong. Please try again or email hello@konekchurch.com.",
    successTitle: "Thank you for contacting Konek Church",
    successBody: "We received your request and will contact you within one business day to discuss your church's giving and digital-growth needs.",
    successEmail: "A confirmation email is on its way to you.",
  },
  schedule: {
    title: "Want to pick a time right now?",
    sub: "Choose a 30-minute slot for your free consultation call (Eastern Time). Or skip — we'll reach out to schedule together.",
    pickDay: "1. Pick a day",
    pickTime: "2. Pick a time",
    confirm: "Confirm This Time",
    confirming: "Scheduling…",
    skip: "Skip — contact me to schedule instead",
    bookedTitle: "Your call is scheduled",
    bookedBody: "We look forward to speaking with you on",
    tz: "All times are Eastern Time (ET) · Mon–Sat, 1:00–7:00 PM",
    noSlots: "No times left this day — please pick another day.",
    toastErr: "Could not schedule that time. Please pick another slot.",
    days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  },
  faq: {
    label: "Questions & Answers",
    title: "Frequently Asked Questions",
    sub: "Clear answers on qualification, fees, timelines, and support — with no fine-print surprises.",
    items: [
      { q: "Who qualifies for a giving device?", a: "Eligibility and merchant approval are determined by participating third-party payment-processing providers, based on the church's application and documentation. We help you understand and complete the application, but the final decision belongs to the provider." },
      { q: "Which payment methods may be accepted?", a: "Depending on provider approval and equipment, supported debit cards, credit cards, chip cards, and contactless payment methods may be accepted. The provider determines the exact methods available to your church." },
      { q: "Who determines processing rates and equipment costs?", a: "Processing rates, transaction fees, equipment costs, deposits, and chargebacks are set and handled by the third-party provider — not by Konek Church." },
      { q: "Does Konek Church hold church donations?", a: "Never. Konek Church is not a payment processor and never holds, transmits, or has access to your church's donation funds. Contributions flow through the approved provider to your church's own account." },
      { q: "How long does a website take?", a: "It depends on your package and how quickly content is provided. Most projects launch within a few weeks. We give a clear estimate during your consultation." },
      { q: "Who owns the website?", a: "Your church. Your website and content belong to your church. Domain, hosting, and third-party software may carry their own separate terms and costs." },
      { q: "Is monthly support available?", a: "Yes — optional care plans start at $149/month. Each plan lists exactly what's included, the update allowance, support method, and response times. Plans are not unlimited." },
      { q: "Can the website be multilingual?", a: "Yes. Our Complete package supports multilingual options, and we serve churches in English, Kreyòl, French, and Spanish." },
      { q: "Who handles device and transaction problems?", a: "The payment-processing provider handles merchant approval, equipment, transactions, deposits, chargebacks, processing rates, and device-related technical support. We help connect you with the right resources." },
      { q: "What happens after the consultation?", a: "You receive a personalized recommendation and a written quote. If you decide to move forward, we sign a service agreement and send a private payment link for the 50% deposit. There is never any obligation after the consultation." },
    ],
    disclaimer: "Payment-processing providers handle merchant approval, equipment, transactions, deposits, chargebacks, processing rates, and device-related technical issues. Konek Church is a digital-services brand and is not a payment processor.",
  },
  finalCta: {
    title: "Make Giving More Accessible—",
    accent: "During Services and Throughout the Week",
    sub: "Give your members and supporters convenient ways to contribute in person, online, or through a church donation QR code — while strengthening your church's digital presence and communication.",
    cta: "Request a Free Device Demonstration",
  },
  footer: {
    tagline: "Digital Giving & Growth Solutions for Churches. Helping ministries modernize giving, communication, and online presence through one connected solution.",
    operated: "Operated by Konekte Haitians LLC",
    getInTouch: "Get in Touch",
    legal: "Legal",
    links: { privacy: "Privacy Policy", terms: "Terms and Conditions", disclosure: "Payment-Processing Disclosure", contact: "Contact" },
    rights: "All rights reserved.",
    note: "Payment-processing services are provided through approved third-party providers. Konek Church is not a payment processor.",
  },
  chat: {
    open: "Ask us anything",
    title: "Konek Assistant",
    subtitle: "AI assistant · answers may contain mistakes",
    welcome: "Hello! I'm the Konek assistant. Ask me anything about giving devices, church websites, pricing, or how to get started — in English or Kreyòl.",
    placeholder: "Type your question…",
    send: "Send",
    error: "Sorry — something went wrong. Please try again, or use the consultation form below.",
    quick: ["How does the giving device work?", "Which package fits a small church?", "What do the monthly plans include?"],
    close: "Close chat",
  },
};

const HT = {
  nav: {
    links: [
      { label: "Akèy", href: "#home" },
      { label: "Kijan Li Mache", href: "#how" },
      { label: "Kesyon", href: "#faq" },
      { label: "Kontak", href: "#contact" },
    ],
    cta: "Mande yon Demonstrasyon Gratis pou Aparèy la",
    language: "Lang",
    comingSoon: (label) => `${label} ap vini talè`,
    comingSoonDesc: "N ap prepare kontni tradui nèt.",
  },
  hero: {
    label: "SOLISYON POU OFRANN AN PÈSÒN AK KWASANS DIJITAL",
    lines: ["Fè Bay Ofrann Pi Fasil.", "Kenbe Legliz Ou", "Konekte."],
    sub: "Bay manm legliz ou yon lòt fason pratik pou yo fè ofrann pandan sèvis yo avèk yon kat ki kalifye oswa yon metòd peman san kontak—ansanm ak sit entènèt pwofesyonèl, ofrann sou entènèt, kòd QR, zouti kominikasyon, fòmasyon, ak sipò dijital kontinyèl.",
    cta1: "Mande yon Demonstrasyon Gratis pou Aparèy la",
    cta2: "Dekouvri Solisyon Nou Yo",
    trust: ["Sèvis klè ak transparan", "Kreye pou ministè", "Sipò nan plizyè lang", "Baze nan Sid Florid"],
    contactless: "San kontak",
    tap: "Tape pou bay",
    imgAlt: "Yon manm k ap tape yon kat san kontak sou yon aparèy ofrann modèn pandan yon sèvis",
  },
  demoCta: {
    title: "Gade Kijan Ofrann an Pèsòn Ka Fèt nan Legliz Ou",
    text: "Mande yon demonstrasyon gratis pou w dekouvri aparèy la, konprann pwosesis kalifikasyon an, epi wè kijan li ka konekte ak sistèm dijital konplè legliz ou.",
    button: "Mande Demonstrasyon Gratis Mwen an",
    note: "Pa gen obligasyon. Apwobasyon founisè a ak disponiblite ekipman an ka nesesè.",
  },
  benefits: {
    label: "Poukisa Legliz Yo Chwazi Konek",
    title: "Twa Fason Konek Sèvi Ministè Ou",
    items: [
      { title: "Plis Fason Pratik pou Bay Ofrann", desc: "Manm ki kalifye yo ka sèvi ak kat ki sipòte oswa metòd peman san kontak pandan sèvis ak evènman yo." },
      { title: "Yon Sèl Sistèm Legliz Konekte", desc: "Aparèy la ka mache ansanm ak yon sit entènèt pwofesyonèl, ofrann sou entènèt, kòd QR, evènman, fòm vizitè, ak zouti kominikasyon." },
      { title: "Fòmasyon ak Sipò Kontinyèl", desc: "Nou ede reprezantan legliz ou konprann ak jere sistèm dijital yo—menm si legliz la pa gen yon anplwaye teknik." },
    ],
  },
  deviceVideo: {
    label: "Demonstrasyon Aparèy la",
    title: "Gade Aparèy Ofrann nan an Aksyon",
    text: "N ap ajoute yon videyo demonstrasyon ofisyèl isit la byento. Annatandan, responsab legliz yo ka mande yon demonstrasyon pèsonalize an dirèk.",
    soonLabel: "Videyo Demonstrasyon Ofisyèl la ap Vini Byento",
    button: "Mande yon Demonstrasyon an Dirèk",
  },
  howGiving: {
    label: "Kijan Ofrann an Pèsòn Fonksyone",
    title: "Twa Etap Senp Pandan Nenpòt Sèvis",
    step: "ETAP",
    steps: ["Chwazi montan ofrann nan", "Tape, mete kat la, oswa itilize yon metòd peman ki kalifye", "Resevwa konfimasyon"],
    usesTitle: "Kote legliz yo itilize li:",
    uses: ["Sèvis adorasyon regilye", "Ofrann espesyal", "Kanpay konstriksyon", "Konferans", "Pwogram pou ranmase fon", "Evènman kominotè"],
    disclaimer: "Apwobasyon, ekipman, frè pwosesis peman, depo, ak kondisyon kontra yo se konpayi ki trete peman yo ki deside yo. Konek Church se pa yon konpayi ki trete peman, e li pa janm kenbe ofrann legliz yo.",
  },
  marquee: ["Kreye pou Ministè", "Ofrann an Sekirite", "Sipò nan Plizyè Lang", "Yon Sèl Patnè Konekte", "Swen pou Kongregasyon Ou"],
  why: {
    label: "Poukisa Konek Church",
    title: "Yon Patnè ki Konprann Ministè Ou",
    sub: "Nou sèvi legliz yo avèk konpreyansyon kiltirèl, swen pèsonèl, ak yon sèl sèvis kowòdone pou ofrann ak sit entènèt.",
    points: [
      "Nou konprann kilti legliz ak bezwen ministè yo",
      "Sèvis pèsonèl, imen — pa janm yon call center",
      "Yon sèl patnè kowòdone pou ofrann ak sit entènèt",
      "Sipò pou legliz ki pa gen ekip teknik",
    ],
    langsTitle: "4 lang",
    langsSub: "Anglè · Kreyòl · Fransè · Panyòl",
    imgAlt: "Yon kominote legliz miltikiltirèl ki kontan, rasanble ansanm",
  },
  how: {
    label: "Kijan Li Mache",
    title: "Yon Chemen Senp Soti nan Lide Rive nan Lansman",
    sub: "Kat etap klè — ou pa bezwen konesans teknik. Nou gide legliz ou nan chak etap.",
    steps: [
      { n: "01", title: "Konsiltasyon Gratis", desc: "Nou aprann konnen legliz ou ak bezwen li yo." },
      { n: "02", title: "Rekòmandasyon Pèsonalize", desc: "Nou rekòmande bon solisyon pou ministè ou ak bidjè ou." },
      { n: "03", title: "Enstalasyon", desc: "Nou kowòdone sèvis apwouve yo epi bati solisyon dijital ou." },
      { n: "04", title: "Lansman & Sipò", desc: "Nou lanse, fòme ekip ou, epi bay sipò lè ou bezwen li." },
    ],
  },
  solutions: {
    label: "Solisyon Dijital Konplè pou Legliz",
    title: "Tout Sa Ministè Ou Bezwen, Konekte",
    sub: "Yon sèl patnè ou ka fè konfyans pou ofrann, sit entènèt, kominikasyon, ak sipò kontinyèl.",
    viewAll: "Gade Tout Solisyon Yo",
    viewLess: "Montre Mwens",
    items: [
      { title: "Asistans Aparèy Ofrann an Pèsòn", desc: "Yon fason senp e fasil pou bay pandan sèvis yo." },
      { title: "Sit Entènèt Legliz Pwofesyonèl", desc: "Yon sit entènèt ki pwòp, akeyan, e ki mache sou telefòn." },
      { title: "Ofrann sou Entènèt", desc: "Bay an sekirite kèlkeswa kote w ye, nenpòt jou." },
      { title: "Kòd QR pou Donasyon", desc: "Kòd tape-pou-bay pou bilten, ekran, ak evènman." },
      { title: "Evènman & Enskripsyon", desc: "Pibliye evènman epi kolekte enskripsyon fasilman." },
      { title: "Difizyon an Dirèk & Predikasyon", desc: "Mete adorasyon ak ansyen mesaj yo sou entènèt." },
      { title: "Fòm Vizitè & Demann Lapriyè", desc: "Akeyi envite yo epi swiv yo avèk swen." },
      { title: "Imèl & Kominikasyon ak Manm", desc: "Bilten ki kenbe tout moun konekte." },
      { title: "Opsyon Plizyè Lang", desc: "Sèvi legliz ou an Anglè, Kreyòl, Fransè, oswa Panyòl." },
      { title: "Fòmasyon", desc: "Nou montre ekip ou kijan pou jere zouti dijital yo ak konfyans." },
      { title: "Sipò Kontinyèl", desc: "Yon patnè ou ka rele lè ou pa gen ekip teknik." },
    ],
  },
  packages: {
    label: "Pri Senp e Aksesib",
    title: "Teknoloji Modèn pou Legliz Dwe Aksesib pou Tout Ministè",
    sub: "Kit ou dirije yon ti kongregasyon oswa yon ministè k ap grandi, n ap ede ou jwenn yon solisyon ki koresponn ak bezwen, objektif, ak bidjè ou.",
    startingAt: "Kòmanse a",
    mostPopular: "Pi Popilè",
    disclaimer: "Pri sèvis Konek Church yo separe de frè pwosesis peman konpayi twazyèm-pati yo, pri ekipman, frè tranzaksyon, hosting, lojisyèl, ak kontra founisè yo. Pri final la depann de bezwen legliz ou.",
    process: "Kijan li mache: Konsiltasyon gratis → Rekòmandasyon pèsonalize → Kontra siyen → Lyen peman prive pou depo 50% lan → Pwodiksyon → Apwobasyon final ak balans ki rete a → Lansman.",
    items: [
      {
        name: "Esansyèl", price: "$997", popular: false,
        tagline: "Yon fason abòdab pou etabli oswa amelyore ofrann dijital ak prezans legliz ou sou entènèt.",
        cta: "Mande yon Konsiltasyon",
        features: ["Asistans pou aplikasyon ak konpayi peman", "Asistans enstalasyon aparèy ofrann ki kalifye", "Sit entènèt legliz esansyèl", "Koneksyon ofrann sou entènèt", "Kòd QR pou donasyon", "Fòm kontak & demann lapriyè", "Koneksyon rezo sosyal", "Fòmasyon debaz & premye sipò sit entènèt"],
      },
      {
        name: "Kwasans", price: "$1,497", popular: true,
        tagline: "Yon sistèm dijital pi solid e pi konplè pou ministè k ap grandi.",
        cta: "Mande yon Konsiltasyon",
        inherits: "Tout sa ki nan Esansyèl, plis:",
        features: ["Sit entènèt pi laj", "Evènman & enskripsyon", "Fòm koneksyon pou vizitè", "Entegrasyon difizyon an dirèk & predikasyon", "Enskripsyon bilten", "Analitik sit entènèt", "Fòmasyon & sipò adisyonèl"],
      },
      {
        name: "Konplè", price: "$2,497", popular: false,
        tagline: "Yon prezans dijital avanse ak teknoloji ministè kontini.",
        cta: "Mande yon Konsiltasyon",
        inherits: "Tout sa ki nan Kwasans, plis:",
        features: ["Sit entènèt pi gwo", "Opsyon plizyè lang", "Plizyè paj kanpay", "Enskripsyon evènman avanse", "Fòm volontè & manm", "Swivi otomatik pou vizitè", "Sistèm randevou / demann pastoral", "Analitik avanse & sipò priyorite"],
      },
    ],
  },
  care: {
    label: "Swen Kontini Opsyonèl",
    title: "Plan Sipò Mansyèl Klè",
    sub: "Kenbe sit entènèt ou an sante e ajou. Chak plan montre egzakteman sa ki enkli, kijan mizajou yo fèt, ak vitès repons nou.",
    notIncluded: "Pa enkli: ",
    plans: [
      {
        name: "Swen Fondasyon", price: "$149", per: "/mwa",
        includes: ["Mizajou lojisyèl & sovgad", "Siveyans sekirite", "Jiska 2 mizajou kontni / mwa", "Sipò pa imèl · repons nan 2 jou ouvrab"],
        excludes: "Nouvo paj, refonte, oswa entegrasyon yo kalkile apa.",
      },
      {
        name: "Swen Kwasans", price: "$299", per: "/mwa",
        includes: ["Tout sa ki nan Swen Fondasyon", "Jiska 5 mizajou kontni / mwa", "Mizajou evènman & fòm + tès", "Rezime analitik chak mwa", "Sipò imèl & tèks · repons nan 1 jou ouvrab"],
        excludes: "Pa enkli gwo refonte oswa nouvo entegrasyon.",
      },
      {
        name: "Jesyon Ministè", price: "$599", per: "/mwa",
        includes: ["Tout sa ki nan Swen Kwasans", "Jiska 10 mizajou kontni / mwa", "Sipò priyorite · repons menm jou ouvrab la", "Asistans kominikasyon", "Rankont estrateji chak trimès"],
        excludes: "Devlopman espesyal kalkile apa. Plan yo pa san limit.",
      },
    ],
  },
  trust: {
    label: "Poukisa Fè Konek Church Konfyans",
    title: "Rankontre Fondatè Konek Church la",
    sub: "Abner Sergilles kreye Konek Church pou ede legliz yo sèvi ak zouti dijital pratik pou ofrann, kominikasyon, koneksyon, ak devlopman ministè. Eksperyans li nan kominote legliz yo ede Konek Church sèvi chak ministè avèk respè, sèvis pèsonalize, ak yon bon konpreyansyon sou bezwen legliz yo.",
    founderName: "Abner Sergilles",
    founderRole: "Fondatè Konek Church",
    facts: [
      { label: "Kote li ye", value: "Sid Florid" },
      { label: "Lang", value: "Anglè, Kreyòl Ayisyen, Fransè & Panyòl" },
      { label: "Imèl", value: "hello@konekchurch.com" },
    ],
    legal: "Konek Church opere pa Konekte Haitians LLC.",
    photoSoon: "Foto fondatè a ap vini byento",
    videoTitle: "Yon Mesaj Fondatè Nou an",
    videoDesc: "Videyo entwodiksyon fondatè a ak prezantasyon Konek Church la ap telechaje isit la byento.",
    cards: [
      { title: "4 lang", desc: "Anglè · Kreyòl · Fransè · Panyòl" },
      { title: "Kondisyon klè e onèt", desc: "Se konpayi twazyèm-pati apwouve ki trete peman yo." },
      { title: "Ministè an premye", desc: "Fèt pou sèvi legliz tout gwosè ak tout bidjè." },
    ],
    firstStory: "Vin youn nan premye legliz nou sèvi yo — istwa ou ta ka parèt isit la.",
  },
  form: {
    label: "Demonstrasyon Gratis",
    title: "Èske Ou Pare pou Dekouvri yon Pi Bon Eksperyans Ofrann pou Legliz Ou?",
    sub: "Kèk ti detay rapid — se sa sèlman. N ap kontakte ou nan yon jou ouvrab. San presyon, san obligasyon.",
    benefits: [
      { t: "Repons nan yon jou ouvrab", d: "Yon vrè moun ap swiv ou rapidman." },
      { t: "Rekòmandasyon pèsonalize", d: "Konsèy pou ministè ou ak bidjè ou." },
      { t: "San obligasyon", d: "Egzamine opsyon ou yo avèk konfyans." },
    ],
    prefer: "Ou prefere pale ak yon moun?",
    contactLabels: { call: "Rele", text: "Tèks", whatsapp: "WhatsApp", email: "Imèl" },
    labels: {
      name: "Non pastè a oswa reprezantan an", church: "Non legliz la", role: "Wòl ou nan legliz la",
      email: "Imèl", phone: "Telefòn", location: "Kote legliz la ye", language: "Lang ou prefere",
      interest: "Mwen enterese nan", contactMethod: "Kijan ou prefere nou kontakte ou",
    },
    placeholders: { name: "Non konplè", church: "Non legliz la", role: "pa egz. Pastè, Dyak, Administratè", email: "ou@legliz.org", phone: "(000) 000-0000", location: "Vil, Eta" },
    interestDevice: "Aparèy ofrann an pèsòn nan",
    interestWebsite: "Yon sit entènèt legliz & zouti dijital",
    contactOptions: [
      { value: "Phone call", label: "Apèl telefòn" },
      { value: "Text message", label: "Mesaj tèks" },
      { value: "WhatsApp", label: "WhatsApp" },
      { value: "Email", label: "Imèl" },
    ],
    hint: "Imèl oswa telefòn — omwen youn.",
    errors: {
      name: "Tanpri antre non ou.",
      church: "Tanpri antre non legliz la.",
      interest: "Tanpri chwazi omwen yon enterè.",
      contact: "Antre yon imèl oswa yon telefòn pou nou ka jwenn ou.",
    },
    optin: 'Mwen dakò pou non legliz mwen parèt nan notifikasyon aktivite resan Konek yo (pa egzanp, "Premye Batis mande yon konsiltasyon").',
    optional: "Opsyonèl.",
    submit: "Mande Demonstrasyon Gratis Mwen an",
    sending: "N ap voye…",
    privacy: "N ap itilize enfòmasyon ou sèlman pou kontakte ou konsènan demonstrasyon ou.",
    toastOk: "Nou resevwa demann ou — n ap kontakte ou nan yon jou ouvrab.",
    toastErr: "Yon bagay pa mache. Tanpri eseye ankò oswa ekri hello@konekchurch.com.",
    successTitle: "Mèsi dèske ou kontakte Konek Church",
    successBody: "Nou resevwa demann ou e n ap kontakte ou nan yon jou ouvrab pou pale sou bezwen ofrann ak kwasans dijital legliz ou.",
    successEmail: "Yon imèl konfimasyon ap rive sou ou.",
  },
  schedule: {
    title: "Ou vle chwazi yon lè kounye a?",
    sub: "Chwazi yon plas 30 minit pou apèl konsiltasyon gratis ou (Lè Lès - ET). Oswa sote — n ap kontakte ou pou nou planifye ansanm.",
    pickDay: "1. Chwazi yon jou",
    pickTime: "2. Chwazi yon lè",
    confirm: "Konfime Lè Sa a",
    confirming: "N ap planifye…",
    skip: "Sote — kontakte m pito pou planifye",
    bookedTitle: "Apèl ou planifye",
    bookedBody: "Nou kontan pou nou pale avèk ou",
    tz: "Tout lè yo se Lè Lès (ET) · Lendi–Samdi, 1:00–7:00 PM",
    noSlots: "Pa gen lè ki rete jou sa a — tanpri chwazi yon lòt jou.",
    toastErr: "Nou pa t ka planifye lè sa a. Tanpri chwazi yon lòt plas.",
    days: ["Dim", "Len", "Mad", "Mèk", "Jed", "Van", "Sam"],
    months: ["Jan", "Fev", "Mas", "Avr", "Me", "Jen", "Jiy", "Out", "Sep", "Okt", "Nov", "Des"],
  },
  faq: {
    label: "Kesyon & Repons",
    title: "Kesyon Moun Poze Souvan",
    sub: "Repons klè sou kalifikasyon, frè, delè, ak sipò — san okenn sipriz nan ti lèt piti.",
    items: [
      { q: "Kiyès ki kalifye pou yon aparèy ofrann?", a: "Se konpayi ki trete peman yo ki deside kalifikasyon ak apwobasyon machann, dapre aplikasyon ak dokiman legliz la. Nou ede ou konprann e konplete aplikasyon an, men desizyon final la se pou founisè a." },
      { q: "Ki metòd peman ki ka aksepte?", a: "Selon apwobasyon founisè a ak ekipman an, kat debi, kat kredi, kat ak chip, ak metòd peman san kontak ki sipòte yo ka aksepte. Se founisè a ki detèmine metòd egzak ki disponib pou legliz ou." },
      { q: "Kiyès ki deside frè pwosesis peman ak pri ekipman?", a: "Frè pwosesis peman, frè tranzaksyon, pri ekipman, depo, ak chargeback yo se konpayi twazyèm-pati a ki fikse e ki jere yo — se pa Konek Church." },
      { q: "Èske Konek Church kenbe ofrann legliz yo?", a: "Jamè. Konek Church se pa yon konpayi ki trete peman, e li pa janm kenbe, voye, oswa gen aksè a lajan ofrann legliz ou. Kontribisyon yo pase nan founisè apwouve a pou rive nan pwòp kont legliz ou." },
      { q: "Konbyen tan yon sit entènèt pran?", a: "Sa depann de pakè ou ak vitès ou bay kontni. Pifò pwojè lanse nan kèk semèn. Nou ba ou yon estimasyon klè pandan konsiltasyon ou." },
      { q: "Kiyès ki mèt sit entènèt la?", a: "Legliz ou. Sit entènèt ou ak kontni li se pou legliz ou. Domèn, hosting, ak lojisyèl twazyèm-pati ka gen pwòp kondisyon ak frè apa yo." },
      { q: "Èske gen sipò mansyèl ki disponib?", a: "Wi — plan swen opsyonèl yo kòmanse a $149/mwa. Chak plan montre egzakteman sa ki enkli, kantite mizajou, metòd sipò, ak tan repons. Plan yo pa san limit." },
      { q: "Èske sit la ka nan plizyè lang?", a: "Wi. Pakè Konplè nou an sipòte opsyon plizyè lang, e nou sèvi legliz an Anglè, Kreyòl, Fransè, ak Panyòl." },
      { q: "Kiyès ki jere pwoblèm aparèy ak tranzaksyon?", a: "Konpayi ki trete peman an jere apwobasyon machann, ekipman, tranzaksyon, depo, chargeback, frè pwosesis peman, ak sipò teknik pou aparèy la. Nou ede konekte ou ak bon resous yo." },
      { q: "Kisa k ap pase apre konsiltasyon an?", a: "W ap resevwa yon rekòmandasyon pèsonalize ak yon estimasyon alekri. Si ou deside kontinye, nou siyen yon kontra sèvis epi nou voye yon lyen peman prive pou depo 50% lan. Pa janm gen okenn obligasyon apre konsiltasyon an." },
    ],
    disclaimer: "Konpayi ki trete peman yo jere apwobasyon machann, ekipman, tranzaksyon, depo, chargeback, frè pwosesis peman, ak pwoblèm teknik aparèy yo. Konek Church se yon mak sèvis dijital e li pa yon konpayi ki trete peman.",
  },
  finalCta: {
    title: "Fè Ofrann Vin Pi Aksesib—",
    accent: "Pandan Sèvis Yo ak Pandan Tout Semèn Nan",
    sub: "Bay manm ou yo ak sipòtè ou yo fason pratik pou kontribye an pèsòn, sou entènèt, oswa atravè yon kòd QR donasyon legliz — pandan w ap ranfòse prezans dijital ak kominikasyon legliz ou.",
    cta: "Mande yon Demonstrasyon Gratis pou Aparèy la",
  },
  footer: {
    tagline: "Solisyon Ofrann Dijital & Kwasans pou Legliz. N ap ede ministè yo modènize ofrann, kominikasyon, ak prezans sou entènèt atravè yon sèl solisyon konekte.",
    operated: "Opere pa Konekte Haitians LLC",
    getInTouch: "Kontakte Nou",
    legal: "Legal",
    links: { privacy: "Politik Konfidansyalite", terms: "Tèm ak Kondisyon", disclosure: "Divilgasyon Tretman Peman", contact: "Kontak" },
    rights: "Tout dwa rezève.",
    note: "Sèvis tretman peman yo fèt atravè konpayi twazyèm-pati apwouve. Konek Church se pa yon konpayi ki trete peman.",
  },
  chat: {
    open: "Poze nou nenpòt kesyon",
    title: "Asistan Konek",
    subtitle: "Asistan AI · repons yo ka gen erè",
    welcome: "Bonjou! Mwen se asistan Konek la. Poze m nenpòt kesyon sou aparèy ofrann, sit entènèt legliz, pri, oswa kijan pou w kòmanse — an Anglè oswa an Kreyòl.",
    placeholder: "Ekri kesyon ou…",
    send: "Voye",
    error: "Padon — yon bagay pa mache. Tanpri eseye ankò, oswa itilize fòm konsiltasyon an anba a.",
    quick: ["Kijan aparèy ofrann lan fonksyone?", "Ki pakè ki bon pou yon ti legliz?", "Kisa plan mansyèl yo enkli?"],
    close: "Fèmen chat la",
  },
};

export const TRANSLATIONS = { en: EN, ht: HT };
